import { useSelector } from 'react-redux';
import { selectAuthOrg, selectAuthUser } from '../features/auth/store/selectors.js';

/**
 * Sidebar identity chip. Always renders the user's display name (with a
 * fallback chain). For B2B users it appends an org-name pill on the right
 * — same surface treatment, different content. The component name is
 * historical; today it's the identity badge, not strictly an "org" badge.
 */
function truncateEmail(email, maxLength = 26) {
  if (!email || email.length <= maxLength) return email;
  const atIndex = email.lastIndexOf('@');
  if (atIndex <= 0) return `${email.slice(0, maxLength - 3)}...`;

  const local = email.slice(0, atIndex);
  const domain = email.slice(atIndex);
  const localLimit = maxLength - domain.length - 3;

  if (localLimit < 4) return `${email.slice(0, maxLength - 3)}...`;
  return `${local.slice(0, localLimit)}...${domain}`;
}

function identityFor(user) {
  if (!user) return { label: 'Account', title: 'Account' };
  const name = user.display_name || user.full_name || user.first_name;
  if (name) return { label: name, title: name };
  if (user.email) return { label: truncateEmail(user.email), title: user.email };
  return { label: 'Account', title: 'Account' };
}

export function OrgBadge() {
  const user = useSelector(selectAuthUser);
  const org = useSelector(selectAuthOrg);
  const identity = identityFor(user);
  return (
    <div className="sb-orgbadge" title={identity.title}>
      <span className="dot" />
      <span className="nm">{identity.label}</span>
      {org?.name && <span className="role">{org.name}</span>}
    </div>
  );
}
